import clsx from 'clsx';
import React, { FunctionComponent, ReactNode } from 'react';

import OutsideClickWrapper from '@/components/OutsideClickWrapper';
import { AUTH_ACTIONS } from '@/constants/constants';

import { FadeInOut } from '../../fade-in-out';
import Typography from '../../typography';
import { IDropDownItem } from '..';

interface Props {
  children: ReactNode;
  type?: 'button' | 'submit';
  dropDownItems: IDropDownItem[];
  positionMenuAbove?: boolean;
  setIsDropDownOpen: Function;
  isDropDownOpen: boolean;
}

const ButtonDropdown: FunctionComponent<Props> = ({
  children,
  dropDownItems,
  setIsDropDownOpen,
  isDropDownOpen,
  positionMenuAbove = false,
  type = 'button',
}) => {
  const getDrowdownItemStyle = (disabled: boolean) => {
    if (!disabled) {
      return 'flex items-center w-full h-8 text-gray-70 text-xs hover:bg-gray-10 px-2';
    }
    return 'flex items-center w-full h-8 text-gray-50 text-xs opacity-75 px-2';
  };

  return (
    <div className="relative h-full flex-grow">
      <OutsideClickWrapper
        className="contents"
        onOutsideClick={() => setIsDropDownOpen(false)}
      >
        {children}
      </OutsideClickWrapper>
      <FadeInOut isVisible={isDropDownOpen}>
        <div
          className={clsx(
            isDropDownOpen ? 'opacity-100' : 'opacity-0',
            'height-full absolute right-0 z-60 w-[172px] overflow-hidden rounded bg-secondary py-2 shadow transition duration-300',
            positionMenuAbove ? 'bottom-[52px]' : 'top-[52px]'
          )}
        >
          {dropDownItems.map(
            ({
              label,
              icon,
              onClick,
              onDisabledClick,
              divider,
              auth,
              authText,
            }) =>
              divider === true ? (
                <div
                  key={0}
                  className="mx-4 my-1 border-[1px] border-b-0 border-gray-10"
                />
              ) : (
                <div
                  key={label}
                  className="group relative"
                  data-tip={
                    auth ? authText ?? `${AUTH_ACTIONS.LOGIN} to access` : ''
                  }
                  id={`select-${label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  <button
                    className={clsx(getDrowdownItemStyle(auth))}
                    disabled={auth && !onDisabledClick} // Disabled if auth is false AND there is no disabled click function
                    type={type === 'button' ? 'button' : 'submit'}
                    onClick={auth ? onDisabledClick : onClick}
                  >
                    <div className="flex items-center">
                      {icon && (
                        <span className="material-icons-outlined pr-2">
                          {icon}
                        </span>
                      )}
                      <Typography variant="h4">{label}</Typography>
                    </div>
                    {auth && (
                      <span className="material-icons ml-auto !text-xs">
                        lock
                      </span>
                    )}
                  </button>
                </div>
              )
          )}
        </div>
      </FadeInOut>
    </div>
  );
};

export default ButtonDropdown;
